'use strict'
/**
 * Monday == self.week 1
 * Tuesday == self.week 2
 * Wednesday == self.week 3
 * etc.
 */
var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')

var Composer = require('./composer')
var RgbColors = require('src/common/app-constants').rgbColors
var Helpers = require('../../common/helpers')

/**
 * Composer layout
 * -----------------------------------------------------------------------------
 */
var Layout = Marionette.View.extend({
  template: require('./templates/layout.html'),
  initialize: function (options) {
    this.currentDay = 0;
    this.routineDays = [[],[],[],[],[],[],[]];

    var self = this;
    var day = 86400;
    self.week = 129600;
    self.day = day;

    self.isDayRoutine = options.dayRoutine
   
    // Offset for the OCD people who cannot handle the fact that the first routine day was a wednesday (unix time 0).
    // A week starts on monday for humans...
    self.timeOffset = 345600;
    // The legacyTimeOffset handles a different offset, because older devices listen to times between
    // 43200 - 129600
    if (options.legacyTimeOffset) {
      self.timeOffset = 43200;
    }
    //self.timeOffset = 0;

    // walk through collection and split into days
    this.collection.each(function (routine) {
      // convert the self.week time format to day format and determine which day encompasses the timestamp
  
      let time = routine.get('time');
      if (time == null) return;

      // remove offset
      time = time - self.timeOffset;
   
      // determine on which day the given time falls
      let dayIndex = null;
      dayIndex = Math.floor( time/ self.day);

      if (!Array.isArray(self.routineDays[dayIndex])) return;

      let value = self.getRoutineValue(routine)
      // console.log(time);
      self.routineDays[dayIndex].push({
        id: routine.cid,
        time: time - ( dayIndex * self.day),
        value: value,
        properties: self.getRoutineProperties(routine)
      })
    
    })


  },
  events: {
    'click .js-change-day': 'onChangeDay',
    'click .js-add-section': 'onAddSection',
    'click .js-remove-section': 'onRemoveSection',
    'click .js-remove-all-sections': 'onRemoveAllSections',
    'click .js-update-section': 'onUpdateSection',
    'click .js-test-section': 'onTestSection',

    'change .js-color-ring-one': 'onColorRingChange',
    'change .js-color-ring-two': 'onColorRingChange',
    'keyup .js-color-r': 'onColorRgbwChange',
    'keyup .js-color-g': 'onColorRgbwChange',
    'keyup .js-color-b': 'onColorRgbwChange',
    'keyup .js-color-w': 'onColorRgbwChange'
  },
  /* Getters */
  getRoutineProperties: function (routine) {
    var properties = {}

    // dissect the color commands and convert to properties
    if (this.options.type === 'color') {
      var commands = routine.get('commands')
      _.forEach(commands, function (command) {
        if (command.key === 'color.set.led1') properties['ring_one'] = command.value
        if (command.key === 'color.set.led2') properties['ring_two'] = command.value
      })
    }

        // dissect the color commands and convert to properties
    if (this.options.type === 'color_rgbw') {
      var commands = routine.get('commands')
      _.forEach(commands, function (command) {
        if (command.key === 'color_rgbw.set.color') {
          var hexChannels = command.value.match(/.{1,2}/g);

          var channels = _.map(hexChannels, (value) => Helpers.hex2dec(value));
//            properties['color'] = channels;
            properties = {
              'color_r':channels[0],
              'color_g':channels[1],
              'color_b':channels[2],
              'color_w':channels[3]
            };

        }
      })
    }

    // if (this.options.)
    return properties
  },
  getRoutineValue: function (routine) {
    // return routine.get('value') || 0
    var command = routine.get('commands')[0]
    if (!command) return 0
    return command.value
  },
  getRoutine: function () {
    let self = this;
    // first store the current day
    this.storeCurrentDay()

    let routineObjects = [];

    let nrOfRoutineDays = this.routineDays.length;

    if (self.options.dayRoutine) {
      nrOfRoutineDays = 1;
    }

    for (let index = 0; index < nrOfRoutineDays; index++) {

      // calculate a positive or negative offset based
      _.forEach(this.routineDays[index], (fragment) => {
        let offset = 0;
        if (parseInt(fragment.time) == 86400) {
          offset = -1;
        }
        fragment.time  = parseInt(fragment.time) + (index * self.day) + offset;
        // add the timeOffset
        fragment.time  = parseInt(fragment.time ) + self.timeOffset;
        routineObjects.push(fragment)
      });
    }

    return routineObjects;

  },
  /* Setters */
  controlsSetValue: function (value) {
    
    if (!value.height) this.el.querySelector('.js-dimlevel-value').value = ''
    if (this.options.type === 'dali') {
      this.el.querySelector('.js-dimlevel-value').value = parseInt(value.height)
    }

    if (this.options.type === 'color_rgbw') {
      this.el.querySelector('.js-color-r').value = value.properties.color_r || 0;
      this.el.querySelector('.js-color-g').value = value.properties.color_g || 0;
      this.el.querySelector('.js-color-b').value = value.properties.color_b || 0;
      this.el.querySelector('.js-color-w').value = value.properties.color_w || 0;
    }
    

 
  },
  controlsSetProperty: function (properties) {
    if (this.options.type === 'color_rgbw') {
      this.el.querySelector('.js-color-r').value = ''
      this.el.querySelector('.js-color-g').value = ''
      this.el.querySelector('.js-color-b').value = ''
      this.el.querySelector('.js-color-w').value = ''
    }
    if (this.options.type === 'color') {
      if (!properties) {
        this.el.querySelector('.js-color-ring-one').value = 0
        this.el.querySelector('.js-color-ring-two').value = 0
        return
      }

      this.el.querySelector('.js-color-ring-one').value = properties.ring_one
      this.el.querySelector('.js-color-ring-two').value = properties.ring_two
    }
  },
  controlsSetTime: function (start, end) {
    function formatTime (dt) {
      var h = dt.getHours(),
        m = dt.getMinutes(),
        s = dt.getSeconds(),
        r = ''
      if (h >= 0) {
        r += (h > 9 ? h.toString() : '0' + h.toString()) + ':'
      }
      r += (m > 9 ? m.toString() : '0' + m.toString())
      return r
    }

    function getTimeFromSeconds (totalSeconds) {
      var dt = new Date('01/01/2000 0:00')
      dt.setSeconds(totalSeconds)
      return formatTime(dt)
    }

    if (!start && !end) {
      this.el.querySelector('.js-section-start-time').innerHTML = '00:00'
      this.el.querySelector('.js-section-end-time').innerHTML = '00:00'
    } else {
      this.el.querySelector('.js-section-start-time').innerHTML = getTimeFromSeconds(start)
      this.el.querySelector('.js-section-end-time').innerHTML = getTimeFromSeconds(end)
    }
  },
  updateComposer: function () {
    var self = this
    var routinesObject = self.routineDays[self.currentDay]
    self.composer.setRoutine(routinesObject)
  },
  getCurrentComposerRoutine: function() {
    let routines =  this.composer.exportRoutine();

    for (let index = 0; index < routines.length; index++) {
      routines[index].time = routines[index].time;
    }
    return routines;
  },
  /* Events */
  onChangeDay: function(ev) {
    let self = this;
    if (ev.target.tagName !== 'LI') return;

    // store the current day
    this.storeCurrentDay()

    // set the new day
    let day = ev.target.getAttribute('data-day');
    this.currentDay = day;
    this.updateComposer()

    // walk through all days and disable

    _.forEach(self.el.querySelectorAll('.js-change-day li'), function (element) {
      element.classList.remove('is-active')

      if (parseInt(element.getAttribute('data-day')) == self.currentDay) {
        element.classList.add('is-active');
      }

    })


  },
  onColorRgbwChange: function() {
    var data = Backbone.Syphon.serialize(this)

    var property = {}
    property['color_r'] = data.color_r || 0;
    property['color_g'] = data.color_g || 0;
    property['color_b'] = data.color_b || 0;
    property['color_w'] = data.color_w || 0;
    this.composer.setProperty(this.el.querySelector('.js-section-id').value, property)
  },
  storeCurrentDay: function() {
    this.routineDays[this.currentDay] = this.getCurrentComposerRoutine();
  },
  onAddSection: function () {
    var data = Backbone.Syphon.serialize(this)
    this.composer.addSection({
      'properties': data,
      'height': _.get(data, 'height') || 100
    }, true)
    
  },
  onRemoveAllSections: function() {
    this.routineDays = [[],[],[],[],[],[],[]];
    this.composer.removeAllSections()
    console.log('ai');
  },
  onRemoveSection: function () {
    if (!this.selectedSection) return
    this.composer.removeSection(this.selectedSection)
  },
  onUpdateSection: function () {
    if (!this.selectedSection) return

    let value

    if (this.options.type === 'dali') {
      value = {'height':this.el.querySelector('.js-dimlevel-value').value}
      this.composer.updateSection(this.selectedSection, value)
    }

    if (this.options.type === 'color_rgbw') {
        this.onColorRgbwChange()
    }


  },
  onTestSection: function () {
      var data = Backbone.Syphon.serialize(this)
  
      var color = []
      color[0] = parseInt(data.color_r) || 0;
      color[1] = parseInt(data.color_g) || 0;
      color[2] = parseInt(data.color_b) || 0;
      color[3] = parseInt(data.color_w) || 0;

      var channels = _.map(color, (value) => Helpers.dec2hex(value));
      
      this.triggerMethod('control:send-command', {
        command: 'color_rgbw.set.color',
        value: channels.join("")
      })
  },
  onColorRingChange: function (ev) {
    var property = {}
    property[ev.target.name] = ev.target.value
    this.composer.setProperty(this.el.querySelector('.js-section-id').value, property)
  },
  onDomRefresh: function () {
    var self = this
    
    // recreate the composer
    setTimeout(function () {
      self.composer = new Composer({
        element: self.el.querySelector('.js-routine-composer'),
        type: self.options.type
      })

      // Update the interface when parts of the routine are selected or deselected
      self.composer.on('deselected', function (data) {
        self.el.querySelector('.js-composer-controls').classList.remove('active-element')
        self.selectedSection = false
        self.controlsSetTime(false, false)
        self.controlsSetProperty(false)
        self.el.querySelector('.js-section-id').value = ''
      })

      self.composer.on('selected', function (data) {
        self.controlsSetTime(data.startTime, data.endTime)
        self.controlsSetProperty(data.properties)
        self.el.querySelector('.js-composer-controls').classList.add('active-element')
        self.selectedSection = data.id
        self.el.querySelector('.js-section-id').value = data.id

        self.controlsSetValue(data)
      })

      self.updateComposer()
    }, 0)
  },
  templateContext: function () {
    var self = this

    return {
      'isWeekRoutine': function () {
        return !self.isDayRoutine
      },
      'getRgbColors': function () {
        return RgbColors
      },
      'getComposerType': function () {
        return self.options.type
      }
    }
  }

})

module.exports.Layout = Layout



// WEBPACK FOOTER //
// ./js/components/routine-composer/view.js